// i18n area 'backups' — locale no-NO (task #171, onda 2): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.no-NO.meta.json.
import type { enUS } from './backups'

export const noNO: typeof enUS = {
  ckpt: {
    contents: 'Tar imot',
    contentsHint:
      'Hva som kan lande her. «Checkpoints» er klyngens konfigurasjon, «Datasikkerhetskopier» er de virtuelle maskinenes: de to lesningene kombineres, ett mål kan ta imot begge.',
    content: { checkpoints: 'Checkpoints', backups: 'Datasikkerhetskopier' },
    destinationsTitle: 'Backup-mål',
    checkpointsTitle: 'Checkpoints',
    restoreTitle: 'Gjenoppretting',
    addDestination: 'Legg til mål',
    addDestinationTitle: 'Legg til backup-mål',
    editDestinationTitle: 'Rediger mål',
    storage: 'Storage',
    storageHint:
      'En dir-aktig storage (dir/NFS/CIFS/CephFS) — artefaktene er vanlige filer under plattformens namespace.',
    schedule: 'Tidsplan',
    scheduleNone: 'Bare manuell',
    scheduleHourly: 'Hver time',
    scheduleDaily: 'Daglig',
    scheduleWeekly: 'Ukentlig',
    scheduleHour: 'Klokkeslett',
    scheduleWeekday: 'Dag',
    scheduleHint:
      'Planlagte checkpoints har ingen operatør som taster masterpassen: keystorens hemmeligheter pakkes som placeholdere.',
    retention: 'Retention',
    retentionHint:
      'Hvor mange planlagte checkpoints som beholdes — sweeperen fjerner de eldste over antallet. Manuelle og pre-gjenopprettings-checkpoints fjernes aldri.',
    paused: 'Satt på pause',
    pausedHint:
      'Operatørens blackout: så lenge pausen varer, planlegges og beskjæres ingenting på dette målet — datapolicyer så vel som checkpoints. Kjøringer som pågår, røres aldri.',
    orphanRuns: '{n} foreldreløse kjøringer',
    orphanRunsHint:
      'Planlagte kjøringer fra policies som ikke lenger finnes på denne destinasjonen: ingen retention styrer dem — aldri talt, aldri ryddet — og bare en hånd sletter dem. Linsen «backups» i tvirt diagnose navngir de fjernede policyene.',
    rescan: 'Gjenadopter artefakter',
    rescanTitle: 'Gjenadopsjon av artefakter for {name}',
    rescanHint:
      'Gjenoppbygger backupkatalogen (VM/CT/App) fra manifestene til artefaktene på destinasjonen. Eksisterende rader røres aldri; backuper av ukjente policyer forblir foreldreløse (beskjæres aldri automatisk). Grepet etter en bootstrap-gjenoppretting.',
    masterpassDrWarning:
      'Katastrofescenario: LUKS-disker kommer BARE tilbake fra et checkpoint MED masterpass. Planlagte checkpoints pakker plassholdere — ta jevnlig et manuelt checkpoint med masterpass.',
    policy: {
      title: 'Policyer for datasikkerhetskopier',
      hint: 'Navngitte policyer: hvilke objekter (kind, tagger, scopes), hvor ofte, når en kjøring kan starte, og hvor mange kopier som beholdes. Innrulleringens gest blir hos objektets eier: tagger tildeles på dets eget scope.',
      add: 'Legg til policy',
      column: 'Datapolicyer',
      name: 'Navn',
      nameHint:
        'Policyens etikett, unik innenfor destinasjonen. Kjøringene følger policyens stabile id: å gi nytt navn er gratis; å slette den gjør kjøringene dens foreldreløse (verken talt eller ryddet).',
      kindLocked: 'Objektfamilien til en eksisterende policy kan ikke endres: opprett en ny policy.',
      kindLabel: 'Objekter',
      kind: { vm: 'Virtuelle maskiner', ct: 'Containere', app: 'Apper' },
      tags: 'Tag-velger',
      tagsHint: 'Par av tag=verdi, kommaseparert, i AND. Tomme tagger og scopes velger ingenting — aldri «alt».',
      scopes: 'Scopes',
      scopesHint: 'Scope-stier (undertrær), kommaseparert, i OR med hverandre.',
      windowStart: 'Vindu fra',
      windowEnd: 'Vindu til',
      windowHint:
        'Utførelsesvindu (HH:MM, lokal tid; en start etter slutten går over midnatt). Det styrer bare STARTEN: en kjøring som går over, drepes aldri.',
      mode: 'Modus',
      modeHint: 'Inkrementell rir på seriefamilien; en brutt serie degraderer til en full, fortalt i journalen.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementell',
      requireQuiesce: 'Krev quiesce (guest agent)',
      paused: 'Policy på pause',
      retentionNone: 'Behold alt',
      retentionCount: 'Antall',
      retentionGfs: 'GFS-ringer',
      gfs: { keepLast: 'Siste', daily: 'Daglige', weekly: 'Ukentlige', monthly: 'Månedlige', yearly: 'Årlige' },
      gfsHint:
        'For hver ring beholdes den nyeste sikkerhetskopien fra hver av de siste N periodene. En beholdt sikkerhetskopi holder hele kjeden sin i live — aldri en basis med foreldreløse.',
      lastRun: 'Siste kjøring',
      neverRan: 'aldri kjørt'
    },
    lastCheckpoint: 'Siste checkpoint',
    neverRun: 'Aldri opprettet',
    createNow: 'Opprett checkpoint',
    createNowTitle: 'Opprett checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Beskytter keystorens hemmelige verdier (argon2id → AES-256-GCM, per verdi). Den lagres aldri: ta vare på den — uten produserer en gjenoppretting placeholdere i stedet for de ekte hemmelighetene.',
    masterpassEmptyHint: 'La stå tomt for å pakke eksplisitte placeholdere i stedet for hemmelighetene.',
    createStarted: 'Checkpoint i gang…',
    destinationInUseError: "'{name}' inneholder fortsatt checkpoints — slett dem først.",
    origin: 'Opphav',
    originManual: 'manuell',
    originSchedule: 'planlagt',
    originPreRestore: 'pre-gjenoppretting',
    originPreChange: 'før endring',
    preChangeRetention: 'Checkpoints før endring',
    preChangeRetentionHint:
      'Tom = deaktivert. Den første konfigurasjonsskrivingen etter en stille periode fryser her den forrige tilstanden (opprinnelse «før endring»); de nyeste beholdes opp til antallet — egen, beskjærbar retensjon.',
    diffTitle: 'Forhåndsvisning av endringer',
    diffFailed: 'Forhåndsvisning mislyktes',
    diffRetry: 'Prøv igjen',
    diffCounts: '{changed} endres · {missing} opprettes · {extra} overflødige · {equal} identiske',
    diffChanged: 'endres',
    diffMissing: 'ville blitt opprettet',
    diffExtra: 'ville blitt slettet',
    diffJsonb: 'jsonb-referanser kan ikke verifiseres før anvendelsen',
    diffSecret: 'forseglede felter, ikke sammenlignbare',
    diffMore: '{n} til…',
    diffNeeded: 'Start aktiveres når forhåndsvisningen speiler utvalget.',
    phase: 'Status',
    phaseRunning: 'i gang',
    phaseComplete: 'fullført',
    phaseError: 'feil',
    secrets: 'Hemmeligheter',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholdere',
    size: 'Størrelse',
    created: 'Opprettet',
    destination: 'Mål',
    download: 'Last ned .tvbk',
    deleteCheckpoint: 'Slett checkpoint',
    noCheckpoints: 'Ingen checkpoints — opprett ett fra et mål.',
    families: 'Familier',
    generation: 'Generasjon',
    completedAt: 'Fullført',
    errorDetail: 'Feildetalj',
    manifest: 'Manifest',
    restoreHint:
      'Last opp et .tvbk-artefakt: exploreren viser hva det inneholder, så velger du hva som skal gjenopprettes og hvordan.',
    uploadFile: 'Last opp en .tvbk-fil',
    uploading: 'Laster opp…',
    uploadFailed: 'Kunne ikke åpne artefaktet',
    explorerTitle: 'Checkpointets innhold',
    checkpointFrom: 'Checkpoint av klusteret {cluster}, opprettet {when} ({origin}, generasjon {generation})',
    otherCluster:
      'Dette checkpointet kommer fra et ANNET kluster ({cluster}) — kryss-kluster-gjenoppretting kommer i en fremtidig runde.',
    encrypted: 'kryptert',
    objectsCount: '{n} objekter',
    mode: 'Modus',
    modeMerge: 'Merge — rekonsilierer: upsert av de valgte, sletter ingenting',
    modeOverwrite:
      'Overwrite — checkpointet vinner: en helt valgt familie erstattes i sin helhet (nåværende rader som mangler i checkpointet dør)',
    restoreMasterpassHint:
      'Masterpassen checkpointet ble opprettet med. Uten gjenopprettes de krypterte hemmelighetene som eksplisitte placeholdere.',
    checkMasterpass: 'Verifiser',
    masterpassOk: 'Riktig masterpass',
    masterpassWrong: 'Feil masterpass',
    parachuteDestination: 'Fallskjerm-mål',
    parachuteHint: 'Før noen rad røres, oppretter tasken her et automatisk pre-gjenopprettings-checkpoint.',
    summaryTitle: 'Hva som vil skje',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'hele familien',
    summaryObjects: '{n} valgte objekter',
    confirmHint:
      'Skriv klusterets navn ({name}) for å bekrefte — en gjenoppretting omskriver den deklarerte konfigurasjonen.',
    confirmField: 'Klusternavn',
    startRestore: 'Gjenopprett',
    restoreRunning: 'Gjenoppretting i gang…',
    restoreDone: 'Gjenoppretting fullført — reconcilerne konvergerer på den nye deklarasjonen.',
    restoreFailed: 'Gjenopprettingen mislyktes',
    discard: 'Forkast',
    selectionEmpty: 'Velg minst én familie eller ett objekt.'
  },

  backup: {
    intro: {
      title: 'Backup av VM- og containerdata',
      subtitle: 'Byggeklossene som ekstern backupprogramvare bruker',
      whatItIs:
        'TVirt eksponerer fire primitiver: quiesced snapshots, change tracking per disk, read-only NBD-eksport og eksport av konfigurasjonen. Veeam, Bacula, Acronis og lignende styrer dem.',
      whatItIsNot:
        'TVirt er ikke et backupprodukt: det planlegger ingenting, håndhever ingen retention og lagrer ikke noe arkiv av dataene dine. Retention, kataloger og gjenopprettingspolicyer blir hos programvaren du allerede bruker.'
    },
    cbt: {
      title: 'Endringssporing',
      colVm: 'VM',
      colDisk: 'Disk',
      colState: 'Tilstand',
      colBitmaps: 'Bitmaps',
      colObservedAt: 'Observert',
      colChangeId: 'Change-ID',
      colMechanic: 'Mekanisme',
      stateActive: 'Aktiv',
      stateInactive: 'Av',
      stateInconsistent: 'Inkonsistent — neste sikkerhetskopi må være full',
      stateBroken: 'Kjede brutt — deaktiver, og aktiver deretter som ny kjede',
      stateSnapshots: 'Alltid på — delta mellom øyeblikksbilder',
      stateUnavailable: 'Ikke tilgjengelig på denne disken',
      mechanic: {
        'qcow2-bitmap': 'qcow2-bitmap',
        'rbd-snapdiff': 'Ceph-snapshotdiff',
        'lvm-thin-delta': 'Thin pool-delta',
        none: 'Ingen'
      },
      empty:
        'Ingen VM-disk. Endringssporing leses per disk: aktiver den på en qcow2-disk, eller ta øyeblikksbilder på rbd/SAN.',
      chainBroken: 'Kjede brutt',
      chainBrokenText:
        'Brutt av en {reason}: {bitmaps}. Deaktiver bitmapen (kjeden er tapt, neste sikkerhetskopi er full), og aktiver den som ny kjede.',
      lineages: 'Epoker',
      epochFrozen: 'frosset i øyeblikksbilde {snapshot}',
      epochLost: 'tapt ({cause})',
      epochRecording: 'tar opp på hodet',
      milestones: 'Milepæler (øyeblikksbilder)',
      enable: 'Aktiver endringssporing',
      disable: 'Deaktiver',
      reset: 'Nullstill',
      changedAreas: 'Endrede områder',
      denied: 'Du mangler rettigheten på denne VM-en',
      enableTitle: 'Aktiver endringssporing',
      disableTitle: 'Deaktiver endringssporing',
      resetTitle: 'Nullstill bitmapen',
      areasTitle: 'Endrede områder',
      bitmapName: 'Bitmapnavn',
      bitmapNameHint: 'Ditt eget navn: tvirt- og tvbk- tilhører plattformen',
      granularity: 'Granularitet (byte)',
      granularityHint: 'En toerpotens; 65536 som standard',
      bitmap: 'Bitmap',
      disableHint: 'Fjerner bitmapen og hele epokehistorikken: neste sikkerhetskopi må være full.',
      resetHint: 'Tømmer bitmapen — en ny basis: en change-ID fra før nullstillingen kan ikke lenger settes sammen.',
      areasFrom: 'Fra øyeblikksbilde',
      areasTo: 'Til øyeblikksbilde',
      areasRun: 'Beregn',
      areasResult: '{count} endrede områder, {bytes}',
      areasEmpty: 'Ingen endrede områder mellom de to øyeblikksbildene',
      areasZero: 'nuller',
      areasMore: 'de første {shown} av {count} vises',
      submit: 'Bekreft',
      error: 'Handlingen for endringssporing mislyktes'
    },
    exports: {
      title: 'Åpne NBD-eksporter',
      colVm: 'VM',
      colDisk: 'Disk',
      colSnapshot: 'Øyeblikksbilde',
      colBitmap: 'Bitmap',
      colPhase: 'Fase',
      colNode: 'Node',
      colEndpoint: 'Endepunkt',
      colExpires: 'Utløper',
      colCreated: 'Åpnet',
      colError: 'Feil',
      phase: {
        preparing: 'Forbereder',
        ready: 'Klar',
        closed: 'Lukket',
        error: 'Mislyktes'
      },
      expiresIn: 'om {minutes} min',
      expired: 'utløpt',
      empty: 'Ingen eksport. En leseøkt serverer én disk ved ett øyeblikksbilde til en NBD-klient; en skriveøkt fyller en urørt disk på en stoppet VM. Begge dør ved utløp.',
      endpointHint: 'TLS med klyngens CA; eksportnavnet er billetten — den dør med økten',
      closeDenied: 'Du mangler rettigheten til å lukke eksporter på denne VM-en',
      open: 'Åpne NBD-eksport',
      openTitle: 'Åpne en NBD-eksport',
      openDisk: 'Disk',
      openBitmap: 'Bitmap (valgfri)',
      openBitmapHint:
        'Publiserer bitmapens epoke frosset i dette øyeblikksbildet som meta-context for de endrede extentene (bare qcow2-disker)',
      openTtl: 'Levetid (minutter)',
      openSubmit: 'Åpne',
      openError: 'Eksporten kunne ikke åpnes',
      colMode: 'Modus',
      mode: {
        read: 'Lesing',
        write: 'Skriving'
      },
      caCertificate: 'Klyngens CA',
      caCopy: 'Kopier PEM',
      caDownload: 'Last ned ca-cert.pem',
      caHint: 'Skriv PEM-en til ca-cert.pem i en privat mappe og koble til med nbds://…?tls-certificates=<mappe> (nbdcopy, nbdinfo) eller --object tls-creds-x509,dir=<mappe>,endpoint=client (qemu-img)',
      caAbsent: 'Økten bærer ingen CA (ingen PKI)',
      openWrite: 'Åpne skrive-eksport',
      openWriteTitle: 'Åpne en skrive-eksport',
      openWriteIntro: 'Disken må være urørt: født tom, aldri skrevet, uten øyeblikksbilde; VM-en stoppet. Gjenopprettingen FYLLER disken, den reparerer den ikke. Mens økten er åpen kan VM-en ikke starte, ta øyeblikksbilde eller klones, og disken kan ikke flyttes.',
      openWriteSubmit: 'Åpne',
      openWriteError: 'Skrive-eksporten kunne ikke åpnes',
      openWriteDenied: 'Du mangler vm.restore.data på denne VM-en',
      openWriteStopped: 'Stopp VM-en for å åpne en skrive-eksport',
      fromDescription: 'Opprett VM fra beskrivelse',
      fromDescriptionTitle: 'Opprett en VM fra en beskrivelse',
      fromDescriptionIntro: 'Beskrivelsen fra export-vm-meta kommer tilbake som en stoppet VM med tomme disker i den beskrevne geometrien — klar for skrive-eksportene, disk for disk. Bytene passerer ikke her: restore-disk (CLI) eller backupproduktets NBD-klient bærer dem.',
      fromDescriptionDoc: 'Beskrivelse (JSON)',
      fromDescriptionDocHint: 'Lim inn dokumentet fra export-vm-meta, eller velg filen',
      fromDescriptionFile: 'Velg fil…',
      fromDescriptionInvalid: 'Teksten er ikke et JSON-dokument',
      fromDescriptionName: 'Navn på den nye VM-en',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Ditt hjemme-scope',
      fromDescriptionStorage: 'Disklagring',
      fromDescriptionStorageHint: 'Hver disk fødes her, i lagringens standardformat',
      fromDescriptionMetadataStorage: 'Metadatalagring',
      fromDescriptionSameAsStorage: 'Samme som diskene',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Uten bridge eller nettverk fødes VM-en uten nettverkskort',
      fromDescriptionNetwork: 'Logisk nettverk (fabric/nettverk)',
      fromDescriptionSubmit: 'Opprett',
      fromDescriptionError: 'VM-en kunne ikke opprettes',
      fromDescriptionDone: 'VM opprettet: {name}',
      fromDescriptionOpen: 'Åpne VM-en',
      fromDescriptionDenied: 'Du mangler vm.create',
      fromDescriptionStillRunning: 'Opprettelsen pågår fortsatt: venter videre'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Datasikkerhetskopier av VM-er',
      titleOnVm: 'Datasikkerhetskopier',
      empty:
        'Ingen sikkerhetskopi. En sikkerhetskopi frakter diskene, UEFI-varstore og vTPM-tilstanden til et mål, og overlever den virtuelle maskinen.',
      colVm: 'VM',
      colCreated: 'Tatt',
      colPhase: 'Utfall',
      colDestination: 'Mål',
      colContains: 'Innhold',
      colSize: 'Størrelse',
      colOrigin: 'Opphav',
      colMode: 'Type',
      retentionChip: 'Oppbevaring',
      retentionHint:
        'Målets oppbevaring kan slette denne sikkerhetskopien uten å spørre: den ble født av en planlegging. Manuelle sikkerhetskopier feies aldri.',
      policyRemoved: 'Policy fjernet: {name}',
      policyRemovedHint:
        'Policyen som planla denne backupen finnes ikke lenger: ingen retention styrer den (ryddes aldri automatisk) — slett den for hånd når den ikke lenger trengs.',
      phase: {
        running: 'Pågår',
        complete: 'Fullført',
        error: 'Mislyktes'
      },
      origin: {
        manual: 'Manuell',
        schedule: 'Planlagt'
      },
      mode: {
        full: 'Full',
        incremental: 'Inkrementell'
      },
      contains: {
        disks: 'Disker',
        varstore: 'UEFI-varstore',
        vtpm: 'vTPM-tilstand',
        snapshots: 'Øyeblikksbilder'
      },
      vmState: {
        stopped: 'VM avslått',
        running: 'VM kjører (varm)'
      },
      artifactClass: { metadata: 'Metadata', data: 'Data', secret: 'Hemmelighet' },
      detail: {
        tabOverview: 'Oversikt',
        tabArtefact: 'Artefakt',
        id: 'Identifikator',
        scope: 'Omfang',
        vmState: 'VM-tilstand ved kopieringen',
        pointInTime: 'Dataenes tidspunkt',
        completedAt: 'Avsluttet',
        node: 'Node som kopierte',
        error: 'Feil',
        path: 'Mappe på lagringen',
        checksum: 'sha256 av manifestet',
        secretsExposed: 'Sensitivt materiale i klartekst',
        secretsExposedYes: 'Ja — målet krypterer ikke',
        secretsExposedNo: 'Nei',
        baseBackup: 'Basissikkerhetskopi',
        tabManifest: 'Manifest',
        manifestHint:
          'Artefaktens indeks i klartekst: én fil per rad med sin sha256. Mappen kan verifiseres uten TVirt — qemu-img, tar og jq holder.',
        manifestEmpty: 'Manifestet lister ingen filer.',
        manifestError: 'Manifestet kan ikke leses',
        colEntry: 'Fil',
        colClass: 'Klasse',
        colSha: 'sha256'
      },
      create: {
        action: 'Sikkerhetskopier nå',
        title: 'Sikkerhetskopier nå',
        submit: 'Start sikkerhetskopieringen',
        destination: 'Mål',
        destinationHint: 'Bare mål som tar imot sikkerhetskopier.',
        noDestinations: 'Ingen mål tar imot sikkerhetskopier: opprett ett under System → Checkpoints.',
        contentsHint:
          'Alle diskene blir med, pluss UEFI-varstore og vTPM-tilstanden. De to siste er selve poenget: en forseglet gjest må kunne starte igjen.',
        error: 'Sikkerhetskopieringen startet ikke',
        stillRunning: 'Sikkerhetskopieringen pågår fortsatt — kopien fortsetter selv om du lukker.',
        vmRunning:
          'Den virtuelle maskinen er {phase}: en sikkerhetskopi krever en stabil VM — avslått for den kalde kopien, kjørende for den varme.'
      },
      restore: {
        action: 'Gjenopprett',
        title: 'Gjenopprett',
        intro:
          'Gjenoppretting er irreversibel. Velg hvor dataene skal tilbake: til en ny maskin, eller oppå den opprinnelige.',
        modeNewVm: 'Gjenopprett til en NY VM',
        modeNewVmHint:
          'Rører ingenting av det som finnes — det er valget man verifiserer en sikkerhetskopi med. Ny identifikator og ferske MAC-adresser.',
        modeOver: 'Overskriv den opprinnelige VM-en',
        modeOverHint: 'Ødelegger mål-VM-ens nåværende data, uten vei tilbake. Den virtuelle maskinen må være avslått.',
        newName: 'Navn på den nye VM-en',
        newNameHint: 'Det må være ledig i målomfanget.',
        storage: 'Lagring for diskene',
        storageHint: 'Obligatorisk: manifestet noterer en disks størrelse og format, aldri lagringen den lå på.',
        metadataStorage: 'Lagring for varstore og vTPM',
        metadataStorageHint: 'Hvor UEFI-identiteten og vTPM-tilstanden lander.',
        sameAsStorage: 'Samme som diskene',
        bridge: 'Vertens bridge',
        bridgeHint:
          'Hvert registrerte nettverkskort kommer tilbake på denne bridgen med en ny MAC. Latt stå tomt fødes VM-en uten kort — det tryggere standardvalget.',
        overwriteTitle: 'Du er i ferd med å overskrive denne VM-en',
        overwriteName: 'Navn',
        overwriteId: 'Identifikator',
        overwriteDisks: 'Disker som blir overskrevet',
        overwriteNoDisks: 'Ingen disker.',
        overwriteKeeps:
          'Urørt blir identifikator, navn, omfang, nettverkskort og MAC-adresser: en sikkerhetskopi er DATAENE, konfigurasjonen er checkpointet.',
        confirmField: 'VM-ens navn',
        confirmHint: 'Skriv {name} for å bekrefte.',
        targetLoading: 'Leser mål-VM-en…',
        targetRunning:
          'Mål-VM-en er {phase}: en gjenoppretting skriver om bytene under gjesten, og krever derfor at den er avslått.',
        targetGone: 'Den opprinnelige VM-en er ikke lenger lesbar: gjenoppretting til en ny VM gjenstår.',
        onlyComplete: 'Sikkerhetskopien er {phase}: bare en fullført sikkerhetskopi kan gjenopprette.',
        submitNewVm: 'Gjenopprett til den nye VM-en',
        submitOver: 'Overskriv',
        error: 'Gjenopprettingen startet ikke',
        stillRunning: 'Gjenopprettingen pågår fortsatt — å kopiere hele disker tar tid.'
      }
    },
    guest: {
      title: {
        ct: 'Datasikkerhetskopier av containere',
        app: 'Datasikkerhetskopier av Apper'
      },
      tabTitle: 'Sikkerhetskopier',
      empty:
        'Ingen sikkerhetskopier. En sikkerhetskopi kopierer de persistente dataene til en destinasjon og overlever objektet sitt.',
      colSubject: {
        ct: 'Container',
        app: 'App'
      },
      colCreated: 'Tatt',
      colPhase: 'Utfall',
      colDestination: 'Destinasjon',
      colContains: 'Innhold',
      colSize: 'Størrelse',
      colOrigin: 'Opprinnelse',
      policyRemoved: 'Policy fjernet: {name}',
      policyRemovedHint:
        'Policyen som planla denne backupen finnes ikke lenger: ingen retention styrer den (ryddes aldri automatisk) — slett den for hånd når den ikke lenger trengs.',
      phase: {
        running: 'Pågår',
        complete: 'Fullført',
        error: 'Mislykket'
      },
      origin: {
        manual: 'Manuell',
        schedule: 'Planlagt'
      },
      state: {
        stopped: 'Objekt stoppet',
        running: 'Objekt i gang (frosset)'
      },
      contains: {
        rootfs: 'Rootfs-tre',
        config: 'Konfigurasjon',
        volumes: 'Persistente volumer',
        root: 'Persistent root'
      },
      artifactClass: {
        metadata: 'Metadata',
        data: 'Data',
        secret: 'Hemmelig'
      },
      create: {
        action: 'Ta sikkerhetskopi nå',
        title: 'Ny sikkerhetskopi',
        submit: 'Start sikkerhetskopien',
        error: 'Sikkerhetskopien startet ikke',
        destination: 'Destinasjon',
        destinationHint: 'Bare destinasjoner som aksepterer datasikkerhetskopier.',
        noDestinations:
          'Ingen destinasjon aksepterer datasikkerhetskopier: legg til “Datasikkerhetskopier” på en destinasjon.',
        hint: {
          ct: 'Hele rootfs-treet reiser med, trofast (numeriske eiere, xattrs, ACL-er), pluss den deklarerte konfigurasjonen i manifestet. En kjørende container FRYSES under hele pakkingen: krasjkonsistent kopi, deklarert.',
          app: 'BARE de persistente volumene (og den persistente rooten) reiser med, pluss konfigurasjonen i manifestet. Det efemere er utelukket ved ratifisering og manifestet navngir det; env-verdier deklarert hemmelige reiser ikke.'
        },
        stillRunning: 'Sikkerhetskopien pågår ennå — å pakke hele trær tar tid.'
      },
      detail: {
        tabOverview: 'Oversikt',
        tabManifest: 'Manifest',
        id: 'Identifikator',
        scope: 'Omfang',
        state: 'Tilstand ved kopien',
        pointInTime: 'Data per øyeblikk',
        completedAt: 'Avsluttet',
        node: 'Node som kopierte',
        error: 'Feil',
        path: 'Katalog på lagringen',
        checksum: 'manifest-sha256',
        manifestHint:
          'Artefaktets indeks: én post per fil med sin sha256 — uten hashene er “sikkerhetskopien er der” en troshandling.',
        manifestError: 'Manifestet kan ikke leses',
        manifestEmpty: 'Ingen artefakter i manifestet.',
        colEntry: 'Fil',
        colClass: 'Klasse',
        colSha: 'sha256',
        excluded: 'Utelukket ved ratifisering (reiser ikke)',
        secretKeys: 'Utelatte hemmelige env-nøkler (#307) — skriv dem inn igjen etter en gjenoppretting'
      },
      restore: {
        action: 'Gjenopprett',
        title: 'Gjenoppretting',
        submit: 'Gjenopprett',
        error: 'Gjenopprettingen startet ikke',
        stillRunning: 'Gjenoppretting pågår ennå — å pakke ut hele trær tar tid.',
        onlyComplete: 'Sikkerhetskopien er {phase}: bare en fullført kopi kan gjenopprette.',
        asNew: {
          ct: 'I en NY container — ødelegger ingenting: gesten man kontrollerer en sikkerhetskopi med',
          app: 'I en NY App — ødelegger ingenting: gesten man kontrollerer en sikkerhetskopi med'
        },
        over: {
          ct: 'OVER kildecontaineren — hele rootfs-treet erstattes',
          app: 'OVER kilde-Appen — innholdet i hvert persistente volum erstattes'
        },
        name: 'Navn på det nye objektet',
        storage: 'Lagring',
        storageHint: 'Der de gjenopprettede dataene lander — manifestet registrerer aldri den tapte poolen.',
        storageDeclared: 'Lagringene deklarert i manifestet',
        bridge: 'Vert-bridge',
        bridgeHint:
          'Hvert registrerte nettkort kommer tilbake på denne bridgen med en fersk MAC. Tom = født frakoblet, den tryggeste standarden.',
        node: 'Node',
        nodeHint: 'Medlemmet Appen gjenfødes på: noden er klynge-identitet og kommer aldri fra manifestet.',
        secretKeysWarning:
          'Env-verdier deklarert hemmelige reiser ikke i sikkerhetskopien: den gjenfødte kopien vil ha dem inn igjen (task-loggen navngir nøklene).',
        overInventory: 'Du er i ferd med å overskrive dette objektet',
        confirmType: 'Skriv {name} for å bekrefte',
        targetGone: 'Kildeobjektet kan ikke lenger leses: gjenoppretting som nytt er fortsatt mulig.',
        targetLoading: 'Leser målobjektet…',
        targetRunning: 'Målobjektet kjører: en gjenoppretting erstatter bytene under gjesten og vil ha det stoppet.'
      }
    }
  }
}
